import styled, { css } from "styled-components/native";
import { rgba } from "polished";
import { TouchableHighlight, Text } from "react-native";
import { EventsProps } from "./types";
import { Theme } from "../../theming/types";
import { borderRadius, compose } from "../../theming/styledSystem";

type StyledEventProps = EventsProps & { theme: Theme };

const buttonStyles = compose(borderRadius);

export const StyledTouchableHighlight = styled(TouchableHighlight)<EventsProps>`
  height: 32px;
  align-self: flex-start;
  justify-content: center;
  background-color: ${({ theme }: StyledEventProps) =>
    theme.colorTokens.component.input.surface};
  padding-left: ${({ theme, isCondensed }: StyledEventProps) =>
    isCondensed ? 10 : theme.space["space-5"]};
  padding-right: ${({ theme, isCondensed }: StyledEventProps) =>
    isCondensed ? 10 : theme.space["space-5"]};
  ${({ isHovered, isPressed, isSelected, theme }: StyledEventProps) =>
    (isHovered || isSelected) &&
    css`
      background-color: ${isPressed
        ? theme.colorTokens.component.button.buttonLink.background.active
        : theme.colorTokens.component.button.tertiary.background.hover};
    `}
  ${({ isCondensed, theme }: StyledEventProps) =>
    !isCondensed &&
    css`
      box-shadow: 0 1px 3px ${rgba(17, 43, 68, 0.12)};
      margin-right: 8px;
      height: 44px;
      border-width: 1px;
      border-radius: ${theme.radii.xs};
      border-color: ${theme.colorTokens.border.default};
    `}
  ${({ isHovered, isCondensed }: StyledEventProps) =>
    isHovered &&
    !isCondensed &&
    css`
      box-shadow: 0 2px 4px ${rgba(17, 43, 68, 0.14)};
    `}
  ${({ isSelected, theme }: StyledEventProps) =>
    isSelected &&
    css`
      background-color: ${theme.colorTokens.component.button.buttonLink
        .background.active};
      border-color: ${theme.colorTokens.border.default};
      box-shadow: none;
    `};
  ${({ isPressed, theme }: StyledEventProps) =>
    isPressed &&
    css`
      border-color: ${theme.colorTokens.border.default};
      background-color: ${theme.colorTokens.component.button.tertiary.background
        .hover};
      box-shadow: none;
    `}

  ${buttonStyles};
`;

export const StyledText = styled(Text)<EventsProps>`
  display: flex;
  justify-content: center;
  font-family: ${({ theme }: StyledEventProps) => theme.fonts.medium};
  font-size: ${({ theme }: StyledEventProps) => theme.fontSizes.s};
  color: ${({ theme }: StyledEventProps) => theme.colorTokens.content.default};
  ${({ isHovered, theme }: StyledEventProps) =>
    isHovered &&
    css`
      color: ${theme.colorTokens.content.default};
    `}
  ${({ isPressed, theme }: StyledEventProps) =>
    isPressed &&
    css`
      color: ${theme.colorTokens.content.default};
    `}
  ${({ isSelected, isPressed, theme }: StyledEventProps) =>
    isSelected &&
    !isPressed &&
    css`
      color: ${theme.colorTokens.component.button.buttonLink.content.active};
    `}
`;
